export const BEDSHEET_SIZES = [
  "60 × 90", "60 × 112", "70 × 110", "72 × 112", "90 × 100", "90 × 108", "96 × 110",
  "90 × 112", "100 × 112", "108 × 108", "108 × 110", "108 × 112", "112 × 112",
];

export const THREAD_COUNTS = ["200 TC", "300 TC", "400 TC", "500 TC"];

export const CATALOGUE_SECTIONS = [
  {
    id: "bed-linen",
    num: "01",
    title: "Bed Linen",
    image: "/catalogue/bed-sheets.jpg",
    intro: "Crisp, well-finished bed linen designed for hotel presentation and everyday hospitality performance.",
    products: [
      {
        name: "Bed Sheets",
        quoteAs: "Bed Sheets",
        image: "/catalogue/bed-sheets.jpg",
        desc: "Hospitality bed sheets crafted in 100% cotton, available in classic weaves suited to premium hotel rooms.",
        specs: ["Reverse Satin 1 cm Stripes — 100% Cotton", "Plain Percale — 100% Cotton"],
        threadCounts: THREAD_COUNTS,
        sizes: BEDSHEET_SIZES,
        custom: true,
      },
      {
        name: "Bed Runners",
        quoteAs: "Bed Runners",
        image: "/catalogue/bed-runner.jpg",
        desc: "Elegant bed runners that complete the presentation of a hotel bed.",
        specs: ["Exotica Silk with Gold Border", "Plain & Quilted finishes"],
        sizes: ["Single — 60 × 18", "Double — 90 × 18"],
      },
    ],
  },
  {
    id: "duvets",
    num: "02",
    title: "Duvets & Duvet Covers",
    image: "/catalogue/duvet.jpg",
    intro: "Comfortable, washable duvets and finely woven cotton duvet covers for a complete bedding presentation.",
    products: [
      {
        name: "Duvets",
        quoteAs: "Duvets",
        image: "/catalogue/duvet.jpg",
        desc: "Micro fabric duvets with poly fibre fill, designed for guest comfort and easy care.",
        specs: ["Micro Fabric with Poly Fibre Fill", "250 GSM", "Washable"],
        sizes: ["Single — 60 × 90", "Queen — 90 × 90", "King — 90 × 100"],
      },
      {
        name: "Duvet Covers",
        quoteAs: "Duvet Covers",
        image: "/catalogue/duvet-cover.jpg",
        desc: "100% cotton duvet covers in weaves that match our bed linen collection.",
        specs: ["Reverse Satin 1 cm Stripes — 100% Cotton", "Plain Percale — 100% Cotton"],
        sizes: ["Single — 62 × 92", "Queen — 92 × 92", "King — 92 × 102"],
        custom: true,
      },
    ],
  },
  {
    id: "pillows",
    num: "03",
    title: "Pillows & Pillow Covers",
    image: "/catalogue/pillows.jpg",
    intro: "Soft, supportive pillows and neatly finished cotton pillow covers for hotel bedding programmes.",
    products: [
      {
        name: "Soft Pillows — Conjugated Fibre",
        quoteAs: "Pillows",
        image: "/catalogue/pillows.jpg",
        desc: "Soft pillows with conjugated fibre fill for comfortable, resilient support.",
        specs: ["Conjugated Fibre Fill"],
      },
      {
        name: "Soft Pillows — Micro Fibre",
        quoteAs: "Pillows",
        image: "/catalogue/pillows.jpg",
        desc: "Micro fibre pillows offering a plush, premium feel for guest rooms.",
        specs: ["Micro Fibre with Conjugated Fill"],
      },
      {
        name: "Pillow Covers — Bag Type",
        quoteAs: "Pillow Covers",
        image: "/catalogue/pillow-covers.jpg",
        desc: "100% cotton bag-type pillow covers in weaves that match our bed linen.",
        specs: ["Reverse Satin 1 cm Stripes — 100% Cotton", "Plain Percale — 100% Cotton"],
        custom: true,
      },
      {
        name: "Pillow Covers — Zip Type",
        quoteAs: "Pillow Covers",
        image: "/catalogue/pillow-covers.jpg",
        desc: "100% cotton zip-type pillow covers for a secure, tailored fit.",
        specs: ["Reverse Satin 1 cm Stripes — 100% Cotton", "Plain Percale — 100% Cotton"],
        custom: true,
      },
    ],
  },
  {
    id: "mattresses",
    num: "04",
    title: "Mattresses & Mattress Protection",
    image: "/catalogue/mattress.jpg",
    intro: "Dependable mattresses and washable protectors built for hospitality use.",
    products: [
      {
        name: "Mattresses",
        quoteAs: "Mattresses",
        image: "/catalogue/mattress.jpg",
        desc: "FR pocketed spring mattresses for consistent comfort across guest rooms.",
        specs: ["FR Pocketed Spring"],
        sizes: ["Single — 78 × 36 × 8", "Queen — 78 × 60 × 8", "King — 78 × 72 × 8"],
      },
      {
        name: "Mattress Protectors",
        quoteAs: "Mattress Protectors",
        image: "/catalogue/mattress-protector.jpg",
        desc: "Quilted, washable protectors that extend mattress life and hygiene.",
        specs: ["150 GSM", "Quilted with Non-Woven Fabric", "Washable"],
        sizes: ["Single — 36 × 78", "Queen — 60 × 78", "King — 72 × 78"],
        custom: true,
      },
    ],
  },
  {
    id: "bath-towels",
    num: "05",
    title: "Bath & Pool Towels",
    image: "/catalogue/bath-towels.jpg",
    intro: "Soft, absorbent towels made for daily hospitality laundering and guest comfort.",
    products: [
      {
        name: "Bath Towels",
        quoteAs: "Bath Towels",
        image: "/catalogue/bath-towels.jpg",
        desc: "Premium bath towels available in a range of GSM weights to suit your property.",
        specs: ["Available GSM: 480 / 520 / 550 / 650 GSM"],
        sizes: ["27 × 54", "30 × 60"],
      },
      {
        name: "Pool Towels",
        quoteAs: "Pool Towels",
        image: "/catalogue/pool-towels.jpg",
        desc: "Generously sized pool towels in classic resort colourways.",
        specs: ["Blue / White", "Yellow / White", "450 GSM"],
        sizes: ["36 × 72"],
      },
    ],
  },
  {
    id: "hand-face-towels",
    num: "06",
    title: "Hand & Face Towels",
    image: "/catalogue/hand-face-towels.jpg",
    intro: "Neatly finished hand and face towels for bathrooms, spas and washrooms.",
    products: [
      {
        name: "Hand Towels",
        quoteAs: "Hand Towels",
        image: "/catalogue/hand-face-towels.jpg",
        desc: "Soft hand towels sized for hotel bathrooms and washroom stations.",
        specs: ["550 GSM"],
        sizes: ["16 × 26"],
      },
      {
        name: "Face Towels",
        quoteAs: "Face Towels",
        image: "/catalogue/hand-face-towels.jpg",
        desc: "Compact face towels for guest bathrooms and spa use.",
        specs: ["550 GSM"],
        sizes: ["12 × 12"],
      },
    ],
  },
  {
    id: "bath-mats",
    num: "07",
    title: "Bath Mats",
    image: "/catalogue/bath-mats.jpg",
    intro: "Thick, absorbent bath mats that stand up to daily hotel use.",
    products: [
      {
        name: "Bath Mats",
        quoteAs: "Bath Mats",
        image: "/catalogue/bath-mats.jpg",
        desc: "Heavyweight bath mats in a classic brown and white colourway.",
        specs: ["Brown & White", "800 GSM"],
        sizes: ["20 × 30"],
      },
    ],
  },
  {
    id: "bath-robes",
    num: "08",
    title: "Bath Robes",
    image: "/catalogue/bath-robes.jpg",
    intro: "Comfortable 100% cotton bath robes for hotel rooms and spas.",
    products: [
      {
        name: "Terry Bath Robes",
        quoteAs: "Bath Robes",
        image: "/catalogue/bath-robes.jpg",
        desc: "Classic 100% cotton terry robes with a soft, absorbent finish.",
        specs: ["100% Cotton Terry", "Free Size"],
      },
      {
        name: "Sheared Terry Bath Robes",
        quoteAs: "Bath Robes",
        image: "/catalogue/bath-robes.jpg",
        desc: "Sheared terry robes with a smooth, velvety outer surface.",
        specs: ["100% Cotton Sheared Terry", "Free Size"],
      },
      {
        name: "Waffle Bath Robes",
        quoteAs: "Bath Robes",
        image: "/catalogue/bath-robes.jpg",
        desc: "Lightweight 100% cotton waffle-weave robes, ideal for warm climates and spas.",
        specs: ["100% Cotton Waffle", "Free Size"],
      },
    ],
  },
  {
    id: "table-textiles",
    num: "09",
    title: "Hospitality & Table Textiles",
    image: "/catalogue/table-napkins.jpg",
    intro: "Finishing touches for dining rooms, banquets and shared spaces.",
    products: [
      {
        name: "Table Napkins",
        quoteAs: "Table Napkins",
        image: "/catalogue/table-napkins.jpg",
        desc: "Elegant table napkins for restaurants and banqueting.",
        specs: ["Maroon"],
        sizes: ["21 × 24"],
      },
    ],
  },
  {
    id: "cushions",
    num: "10",
    title: "Cushions & Cushion Covers",
    image: "/catalogue/cushions.jpg",
    intro: "Accent cushions and covers that complete the guest room.",
    products: [
      {
        name: "Regular Cushions",
        quoteAs: "Cushions",
        image: "/catalogue/cushions.jpg",
        desc: "Washable poly fibre cushions for everyday hospitality use.",
        specs: ["Poly Fibre", "Washable"],
        sizes: ["16 × 16"],
      },
      {
        name: "Premium Cushions",
        quoteAs: "Cushions",
        image: "/catalogue/cushions.jpg",
        desc: "Hollow fibre cushions with a fuller, premium feel.",
        specs: ["Hollow Fibre", "Washable"],
        sizes: ["16 × 16"],
      },
      {
        name: "Cushion Covers",
        quoteAs: "Cushion Covers",
        image: "/catalogue/cushions.jpg",
        desc: "Exotica silk cushion covers with gold piping for a refined accent.",
        specs: ["Exotica Silk with Gold Piping"],
        sizes: ["16 × 16"],
        custom: true,
      },
    ],
  },
  {
    id: "blankets",
    num: "11",
    title: "Blankets",
    image: "/catalogue/blankets.jpg",
    intro: "Warm, soft fleece blankets for guest rooms and additional bedding.",
    products: [
      {
        name: "Fleece Blankets",
        quoteAs: "Fleece Blankets",
        image: "/catalogue/blankets.jpg",
        desc: "Soft fleece blankets available with or without a satin border.",
        specs: ["With Satin Border", "Without Satin Border"],
        sizes: ["60 × 90", "90 × 90"],
      },
    ],
  },
];

export const CATALOGUE_STATEMENTS = [
  "Consistent quality and professional service are at the heart of our hospitality supply.",
  "Built to meet the demanding requirements of hospitality businesses.",
  "Reliable products and customized solutions for hospitality requirements.",
];

export const PDF_PATH = "/Amazing-Grace-Product-Catalogue.pdf";
